<script>
export default {
  name: 'Blur',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    curvy: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div class="root">
    <div :class="{ primary: true, blur: true, active, curvy }">
      <slot name="primary"></slot>
    </div>
    <div v-if="active" class="secondary">
      <slot name="secondary"></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.root {
  position: relative;
}

.primary {
  display: flex;
  flex-grow: 1;
}

.blur {
  &.active {
    background-color: rgba(20, 24, 24, 0.7);
    -webkit-filter: blur(4px);
    -moz-filter: blur(4px);
    -ms-filter: blur(4px);
    -o-filter: blur(4px);
    filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
  }

  &.curvy {
    border-radius: 16px;
  }
}

.secondary {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
}

@media (max-width: $mobile) {
  .blur {
    &.curvy {
      border-radius: 0;
    }
  }
}
</style>
